import { AfterContentInit, Component, ElementRef, HostBinding, Input, OnChanges, inject, ChangeDetectionStrategy } from '@angular/core';
import { ProductAdditions, ProductDetails } from 'src/app/models';
import { ContentService } from 'src/app/services/content/content.service';
import { KioskService } from 'src/app/services/kiosk/kiosk.service';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { ProductCardComponent } from 'src/app/shared/components/product/card';
import { ContentSection } from 'src/app/shared/layout/content-section';

@Component({
  selector: 'app-product-additions',
  templateUrl: './product-additions.component.html',
  styleUrls: ['./product-additions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ProductCardComponent],
})
export class ProductAdditionsComponent extends ContentSection implements AfterContentInit, OnChanges {
  private themeService = inject(ThemeService);
  private kioskService = inject(KioskService);
  private elRef = inject(ElementRef);

  @Input() additions: ProductAdditions;

  @HostBinding('class.kiosk') isKiosk: boolean;

  title: string;
  products: ProductDetails[];

  constructor() {
    const contentService = inject(ContentService);
    super(contentService, 'productInfo');

    this.isKiosk = this.kioskService.isKiosk;
  }

  ngAfterContentInit() {
    this.themeService.subscribeComponent(this.elRef);
  }

  ngOnChanges() {
    const { name, products } = this.additions;

    this.title = name;
    this.products = products;
  }
}
